<ul class="nav nav-pills flex-column mb-auto gap-1">
  <ng-content></ng-content>
</ul>
@if (version) {
  <div class="d-flex gap-2 justify-content-center align-items-center small" [title]="commit">Build {{ version }}</div>
}
<div class="d-flex gap-2 justify-content-center align-items-center small px-3">
  <div>Powered by</div>
  <div>
    <img src="/images/stantum-logo.png" width="20" height="20" alt="Stantum" />
  </div>
  <div>
    <a href="https://stantum.eu/">Stantum s.r.o</a>
  </div>
</div>
